<input type="checkbox" id="toggle" class="toggleCheckbox" [value]="value" [checked]="value" [(ngModel)]="value"/>
<label for="toggle" class='toggleContainer'>
  <div translate>SWITCH_SEND_RECEIVE_SEND_TEXT</div>   
  <div translate>SWITCH_SEND_RECEIVE_RECEIVE_TEXT</div>
</label>

